/* eslint-disable max-len */
// This file is auto generated by before-build.js and will be overwritten with each "ionic cap sync/copy"
export const AppVersion = JSON.parse("{\"flavor\":\"PRD\",\"gitHash\":\"b2397d6e4a030778f889ecd532eacf8ed2c9cae1\",\"appVersion\":\"0.0.1\",\"buildTimestamp\":1783591720141}")
